<template>
    <v-flex>
        <v-layout row class="content-header">
            <v-flex md12 class="content-title">
                <h2>Documentos</h2>
                <h4>Não se preoculpe com a papelada, aqui está tudo organizado.</h4>
            </v-flex>
        </v-layout>
        <v-layout row class="content-body overflow-y-auto">
            <v-flex md12>
                <v-data-table
                    :headers="headers"
                    :items="documentos"
                    :items-per-page="8"
                    :sort-by="['ano']"
                    :sort-desc="[true]"                      
                    class="">
                    <template v-slot:item.arquivo="{ item }">
                        <img class="hover" src="/img/icon-pdf.png" @click="gerarArquivo(item.arquivo)" />
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>

    import Vue from 'vue';
    import { mapState, mapGetters } from 'vuex';
    export default {
        data() {
            return {
                headers: [
                    {text: "Norma", value: "norma", sortable: true},
                    {text: "Assunto", value: "assunto", sortable: true},
                    {text: "Orgão Emissor", value: "orgao", sortable: true},
                    {text: "Ano", value: "ano", sortable: true},
                    {text: "Download", value: "arquivo", sortable: false},
                ],
                documentos: []
            }
        },
        methods: {
            requestDocumentos(){
                this.documentos = [
                    {
                        norma: "CIRCULAR SUSEP N.º 510, DE 22 DE JANEIRO DE 2015.",
                        assunto: "Dispõe sobre o registro de corretor de seguros, de capitalização e de previdência, pessoa física e pessoa jurídica, e sobre a atividade de corretagem de seguros, de capitalização e de previdência, e dá outras providências.",
                        orgao: "SUSEP",
                        ano: "2015",
                        arquivo: process.env.VUE_APP_API_RAIZ_ARQUIVO + "ajuda/Circ510-15_comp_08_07_16.pdf"
                    },
                    {
                        norma: "CIRCULAR SUSEP Nº 480, DE 18 DE DEZEMBRO DE 2013.",
                        assunto: "Disciplina a oferta de planos de seguro por organizações varejistas em nome de sociedades seguradoras.",
                        orgao: "SUSEP",
                        ano: "2013",
                        arquivo: process.env.VUE_APP_API_RAIZ_ARQUIVO + "ajuda/Circ480.pdf"
                    },
                    {
                        norma: "CIRCULAR SUSEP Nº 567, DE 27 DE FEVEREIRO DE 2018.",
                        assunto: "Suspende o recadastramento das sociedades corretoras de seguros.",
                        orgao: "SUSEP",
                        ano: "2018",
                        arquivo: process.env.VUE_APP_API_RAIZ_ARQUIVO + "ajuda/Circ567.pdf"
                    },
                    {
                        norma: "DECRETO-LEI Nº 73, DE 21 DE NOVEMBRO DE 1966.",
                        assunto: "Dispõe sôbre o Sistema Nacional de Seguros Privados, regula as operações de seguros e resseguros e dá outras providências.",
                        orgao: "GOVERNO",
                        ano: "1966",
                        arquivo: process.env.VUE_APP_API_RAIZ_ARQUIVO + "ajuda/Del0073.pdf"
                    },
                    {
                        norma: "LEI No 4.594, DE 29 DE DEZEMBRO DE 1964.",
                        assunto: "Regula a profissão de corretor de seguros.",
                        orgao: "GOVERNO",
                        ano: "1964",
                        arquivo: process.env.VUE_APP_API_RAIZ_ARQUIVO + "ajuda/L4594.pdf"
                    },
                    {
                        norma: "RESOLUÇÃO CNSP No 249, de 2012.",
                        assunto: "Dispõe sobre a atividade dos corretores de seguros de ramos elementares e dos corretores de seguros de vida, capitalização e previdência, bem como seus prepostos.",
                        orgao: "CNSP",
                        ano: "2012",
                        arquivo: process.env.VUE_APP_API_RAIZ_ARQUIVO + "ajuda/resol249-12_comp_06_01_15.pdf"
                    },
                    {
                        norma: "",
                        assunto: "Politica Comercial",
                        orgao: "",
                        ano: "",
                        arquivo: process.env.VUE_APP_API_RAIZ_ARQUIVO + "ajuda/PolComdf38cba7e254dbcc898d6ab91f4170c4.pdf"
                    },
                    {
                        norma: "",
                        assunto: "Boas Práticas",
                        orgao: "",
                        ano: "",
                        arquivo: process.env.VUE_APP_API_RAIZ_ARQUIVO + "ajuda/BPcfc28268d8ec321e2138e23c9a51c375.pdf"
                    },
                    {
                        norma: "",
                        assunto: "Contrato de Corretagem",
                        orgao: "",
                        ano: "2020",
                        arquivo: process.env.VUE_APP_API_RAIZ_ARQUIVO + "ajuda/contratoCorretagem_d7e1fcfe6aae23c19e69511c48e37a73.pdf"
                    },                    
                    {
                        norma: "",
                        assunto: "Contrato de Corretagem",
                        orgao: "",
                        ano: "2021",
                        arquivo: "/upload/sou_mais/20210713_modelo_contrato_corretagem.pdf"
                    },
                ]
            },
            gerarArquivo(value){
                window.open(value, "_blank");
            }
        },
        computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
        },
        mounted(){
            this.usuario;
            this.requestDocumentos();
        }        
    }
</script>
